var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenceTopIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 18.6677H2.66665C1.41891 18.7051 0.375799 17.7266 0.333313 16.4791V2.18857C0.375795 0.941179 1.41911 -0.0369288 2.66665 0.00107074H21.3333C22.5809 -0.0369288 23.6242 0.941179 23.6666 2.18857V16.4802C23.6235 17.7273 22.5806 18.7051 21.3333 18.6677Z",
    fill: "#c59d48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6683 14.0007H5C5.08578 13.0347 5.5429 12.1397 6.27517 11.504C7.09046 10.6952 8.18595 10.2314 9.33417 10.209C10.4824 10.2314 11.5779 10.6952 12.3932 11.504C13.1252 12.1399 13.5823 13.0348 13.6683 14.0007ZM19 12.834H15.5V10.5007H19V12.834ZM9.33417 9.334C8.70892 9.35573 8.10272 9.11688 7.66034 8.6745C7.21795 8.23212 6.97911 7.62592 7.00083 7.00067C6.97946 6.37552 7.21842 5.76953 7.66072 5.32722C8.10303 4.88492 8.70902 4.64596 9.33417 4.66734C9.95931 4.64596 10.5653 4.88492 11.0076 5.32722C11.4499 5.76953 11.6889 6.37552 11.6675 7.00067C11.6892 7.62592 11.4504 8.23212 11.008 8.6745C10.5656 9.11688 9.95941 9.35573 9.33417 9.334ZM19 8.16734H14.3333V5.834H19V8.16734Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceTopIcn);
export default __webpack_public_path__ + "static/media/licence-top-icn.6566d1bab62491a27dc05d40b3b5d869.svg";
export { ForwardRef as ReactComponent };